/*
    Create by BaiZhiming 2016-1-18
*/
'use strict';
angular.module('trsTransferModule', ['addTenantModule', 'deptAndUserModule', 'selectUserModule', 'selectRoleModule', 'selectDeptModule', 'createTaskModule', 'selectPowerRoleModule'])
    .factory('trsTransferService', ['$modal', function($modal) {
        return {
            getDeptAndUser: function(roleid, success, selected, title) {
                var modalInstance = $modal.open({
                    templateUrl: './components/service/transfer/template/deptAndUser_tpl.html',
                    windowClass: 'transferWindow',
                    backdrop: false,
                    controller: 'deptAndUserCtrl',
                    resolve: {
                        roleid: function() {
                            return roleid;
                        },
                        selected: function() {
                            return selected;
                        },
                        title: function() {
                            return title;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [getUser description：获取用户]
             * @param  {[fn]} success  [description:回调函数]
             * @param  {[obj]} 传入参数 [description：参数属性 rightFilter:是否权限过滤组织树]
             * @return {[type]}             [description]
             */
            getUser: function(success, params, selectedUser) {
                var modalInstance = $modal.open({
                    templateUrl: './components/service/transfer/template/user_tpl.html',
                    windowClass: 'transferWindow',
                    backdrop: false,
                    controller: 'selectUserCtrl',
                    resolve: {
                        params: function() {
                            return params;
                        },
                        selectedUser: function() {
                            return selectedUser;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [getRole description] 获取角色方法
             * @param  {[type]} title   [description] 弹窗标题
             * @param  {[type]} groupId [description] 需要定位到的组织ID，一番填当前用户所属组织ID
             * @param  {[type]} roleId  [description] 当前用户的角色id  没有时填空字符串
             * @param  {[type]} itemsd  [description] 之前已选中的角色列表
             * @param  {[type]} success [description] 成功回调函数
             * @return {[type]}         [description]
             */
            getRole: function(title, groupId, roleId, itemsd, success) {
                var modalInstance = $modal.open({
                    templateUrl: './components/service/transfer/template/role_tpl.html',
                    windowClass: 'transferWindow',
                    backdrop: false,
                    controller: 'selectRoleCtrl',
                    resolve: {
                        itemsd: function() {
                            return itemsd;
                        },
                        title: function() {
                            return title;
                        },
                        groupId: function() {
                            return groupId;
                        },
                        roleId: function() {
                            return roleId;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            getPowerRole: function(title, groupId, itemsd, success) {
                var modalInstance = $modal.open({
                    templateUrl: './components/service/transfer/template/powerRole_tpl.html',
                    windowClass: 'manageConfig-powerRole-window',
                    backdrop: false,
                    controller: 'selectPowerRoleCtrl',
                    resolve: {
                        itemsd: function() {
                            return itemsd;
                        },
                        title: function() {
                            return title;
                        },
                        groupId: function() {
                            return groupId;
                        }
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            getDept: function(date, success) {
                var modalInstance = $modal.open({
                    templateUrl: './components/service/transfer/template/dept_tpl.html',
                    windowClass: 'manageConfig-privilegedAssignment-window createTopicmodal',
                    backdrop: false,
                    controller: 'selectDeptCtrl',
                    resolve: {
                        crTime: date
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            createTask: function(success) {
                var modalInstance = $modal.open({
                    templateUrl: './components/service/transfer/template/createTask.html',
                    windowClass: 'manageConfig-privilegedAssignment-window ',
                    backdrop: false,
                    controller: 'createTaskCtrl',
                    resolve: {}
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            setTopic: function(topic) {
                var modalInstance = $modal.open({
                    templateUrl: './components/service/transfer/template/setTopic.html',
                    windowClass: 'manageConfig-privilegedAssignment-window createTopicmodal',
                    backdrop: false,
                    controller: 'setTopicCtrl',
                    resolve: { topic: topic }
                });
                return modalInstance;
            },
            addTenant: function(options, success) {
                var modalInstance = $modal.open({
                    templateUrl: './components/service/transfer/template/addTenant_tpl.html',
                    windowClass: 'editor_window_class',
                    backdrop: false,
                    controller: 'addTenantCtrl',
                    resolve: {
                        options: options
                    }
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            }
        };
    }]);
